import photoAndrianLecaImg from 'images/about-us/Andrian_Leca.webp';
import photoAlexandrinPatronImg from 'images/about-us/Alexandrin_Patron.webp';
import photoButchWilsonImg from 'images/about-us/Butch_Wilson.webp';
import photoDanaSingerImg from 'images/about-us/Dana_Singer.webp';
import photoEcaterinaSharapovaImg from 'images/about-us/Ecaterina_Sharapova.webp';
import photoElenaLucaImg from 'images/about-us/Elena_Luca.webp';
import photoJosephDiMelisImg from 'images/about-us/Joseph_DiMelis.webp';
import photoMihaiBudacImg from 'images/about-us/Mihai_Budac.webp';
import photoRuxandraCreizanImg from 'images/about-us/Ruxandra_Creizan.webp';
import photoSergheiBusmachiuImg from 'images/about-us/Serghei_Busmachiu.webp';
import photoDumitruBoscaneanImg from 'images/about-us/Dumitru_Boscanean.webp';
import photoValeriaLozovanuImg from 'images/about-us/Valeria_Lozovanu.webp';
import photoAnthonyByfieldImg from 'images/about-us/Anthony_Byfield.webp';
import photoChristopherJohnsonImg from 'images/about-us/Christopher_Johnson.webp';
import photoJohnWinderImg from 'images/about-us/John_Winder.webp';
import photoRajTankImg from 'images/about-us/Raj_Tank.webp';
import photoRandallBrooksImg from 'images/about-us/Randall_Brooks.webp';
import photoRyanWheelerImg from 'images/about-us/Ryan_Wheeler.webp';
import photoSinaMohseninejadImg from 'images/about-us/Sina_Mohseninejad.webp';
import photoTylerDuclosImg from 'images/about-us/Tyler_Duclos.webp';
import photoDenisMezerImg from 'images/about-us/Denis_Mezer.webp';
import photoAndreiUrecheImg from 'images/about-us/Andrei_Ureche.webp';
import photoBenjimenSkibaImg from 'images/about-us/Benjimen_Skiba.webp';
import photoJohnathanDoyleImg from 'images/about-us/Johnathan_Doyle.webp';
import photoMattLuttonImg from 'images/about-us/Matt_Lutton.webp';
import photoMatthewFranklinImg from 'images/about-us/Matthew_Franklin.webp';
import photoQuranOsirisImg from 'images/about-us/Quran_Osiris.webp';
import photoSergiuCureaImg from 'images/about-us/Sergiu_Curea.webp';
import photoWilliamCarithersImg from 'images/about-us/William_Carithers.webp';
import photoWilliamOldImg from 'images/about-us/William_Old.webp';
import photoDavidSumnerImg from 'images/about-us/David_Sumner.webp';
import photoMohammedSadiqMabekoImg from 'images/about-us/Mohammed_Sadiq_Mabeko.webp';
import photoAlexandruRaileanImg from 'images/about-us/Alexandru_Railean.webp';
import photoIonUntilaImg from 'images/about-us/Ion_Untila.webp';
import photoIonutCiobanuImg from 'images/about-us/Ionut_Ciobanu.webp';
import photoIvanPoclitariImg from 'images/about-us/Ivan_Poclitari.webp';
import photoDanielaJurjaImg from 'images/about-us/Cristina_Cocieru.webp';
import photoCristinaCocieruImg from 'images/about-us/Daniela_Jurja.webp';
import photoVadimUncuImg from 'images/about-us/Vadim_Uncu.webp';
import associationLogo1Img from 'images/about-us/associationLogo1.webp';
import associationLogo2Img from 'images/about-us/associationLogo2.webp';
import associationLogo3Img from 'images/about-us/associationLogo3.webp';
import associationLogo4Img from 'images/about-us/associationLogo4.webp';
import associationLogo5Img from 'images/about-us/associationLogo5.webp';
import associationLogo6Img from 'images/about-us/associationLogo6.webp';
import associationLogo7Img from 'images/about-us/associationLogo7.webp';
import associationLogo8Img from 'images/about-us/associationLogo8.webp';
import associationLogo9Img from 'images/about-us/associationLogo9.webp';
import associationLogo10Img from 'images/about-us/associationLogo10.webp';
import associationLogo11Img from 'images/about-us/associationLogo11.webp';
import associationLogo12Img from 'images/about-us/associationLogo12.webp';
import ourPartnersLogo1Img from 'images/about-us/ourPartnersLogo1.webp';
import ourPartnersLogo2Img from 'images/about-us/ourPartnersLogo2.webp';
import ourPartnersLogo3Img from 'images/about-us/ourPartnersLogo3.webp';
import ourPartnersLogo4Img from 'images/about-us/ourPartnersLogo4.webp';
import ourPartnersLogo5Img from 'images/about-us/ourPartnersLogo5.webp';
import ourPartnersLogo6Img from 'images/about-us/ourPartnersLogo6.webp';
import ourPartnersLogo9Img from 'images/about-us/ourPartnersLogo9.webp';
import ourPartnersLogo10Img from 'images/about-us/ourPartnersLogo10.webp';
import ourPartnersLogo11Img from 'images/about-us/ourPartnersLogo11.webp';
import ourPartnersLogo12Img from 'images/about-us/ourPartnersLogo12.webp';
import ourPartnersLogo13Img from 'images/about-us/ourPartnersLogo13.webp';
import ourPartnersLogo14Img from 'images/about-us/ourPartnersLogo14.webp';
import ourPartnersLogo15Img from 'images/about-us/ourPartnersLogo15.webp';
import ourPartnersAlaskaImg from 'images/about-us/ourPartnersAlaska.webp';
import ourPartnersAlaskaTelecomImg from 'images/about-us/ourPartnersAlaskaTelecom.webp';
import ourPartnersAstoundLogoImg from 'images/about-us/ourPartnersAstoundLogo.webp';
import ourPartnersAptitudeLogoImg from 'images/about-us/ourPartnersAptitudeLogo.webp';
import ourPartnersATTLogoImg from 'images/about-us/ourPartnersATTLogo.webp';
import ourPartnersFrontierCommunicationsLogoImg from 'images/about-us/ourPartnersFrontierCommunicationsLogo.webp';
import ourPartnersAlticeLogoImg from 'images/about-us/ourPartnersAlticeLogo.webp';
import ourPartnersFatbeamLogoImg from 'images/about-us/ourPartnersFatbeamLogo.webp';
import ourPartnersEricssonLogoImg from 'images/about-us/ourPartnersEricssonLogo.webp';
import ourPartnersMaxxSouthLogoImg from 'images/about-us/ourPartnersMaxxSouthLogo.webp';
import ourParnersSpectrumLogoImg from 'images/about-us/ourParnersSpectrumLogo.webp';
import ourPartnersCharterLogoImg from 'images/about-us/ourPartnersCharterLogo.webp';
import ourPartnersComcastLogoImg from 'images/about-us/ourPartnersComcastLogo.webp';
import ourPartnersClearwaveLogoImg from 'images/about-us/ourPartnersClearwaveLogo.webp';
import ourPartnersConsolidatedLogoImg from 'images/about-us/ourPartnersConsolidatedLogo.webp';
import ourPartnersDishLogoImg from 'images/about-us/ourPartnersDishLogo.webp';
import ourPartnersWyyerdLogoImg from 'images/about-us/ourPartnersWyyerdLogo.webp';
import ourPartnersLumosLogoImg from 'images/about-us/ourPartnersLumosLogo.webp';
import ourPartnersTeslaLogoImg from 'images/about-us/ourPartnersTeslaLogo.webp';
import teamDescriptionBgPhotoImg from 'images/about-us/teamDescriptionBgPhoto.webp';
import teamDescriptionPhotoImg from 'images/about-us/teamDescriptionPhoto.webp';
import photoJasonMcCoyImg from 'images/about-us/photoJasonMcCoy.webp';
import photoJuanDelCalvoImg from 'images/about-us/photoJuanDelCalvo.webp';
import photoCharlesHouserImg from 'images/about-us/photoCharlesHouser.webp';
import photoTatianaLeahoviciImg from 'images/about-us/Tatiana_Leahovici.webp';
import photoEdwardJaresImg from 'images/about-us/photoEdwardJares.webp';
import photoKyleClausenImg from 'images/about-us/photoKyleClausen.webp';
import photoCraigTonksImg from 'images/about-us/photoCraigTonks.webp';
import photoIvanGalkinImg from 'images/about-us/Ivan_Galkin.webp';
import photoRandyMantioneImg from 'images/about-us/Randy_Mantione.webp';
import photoBrentCollinsImg from 'images/about-us/Brent_Collins.webp';
import photoIgorPapoImg from 'images/about-us/Igor_Papo.webp';
import photoJohnathanMathewLImg from 'images/about-us/Johnathan_Mathew_L.webp';
import photoSteveSizemoreImg from 'images/about-us/Steve_Sizemore.webp';
import photoAlexandruBuseImg from 'images/about-us/Alexandru_Buse.webp';
import photoBulatOlegImg from 'images/about-us/Bulat_Oleg.webp';
import photoBrianBertrandImg from 'images/about-us/Brian_Bertrand.webp';
import photoMatthewStewartImg from 'images/about-us/Matthew_Stewart.webp';
import photoViktorPilgunImg from 'images/about-us/Viktor_Pilgun.webp';
import photoMarkClemensImg from 'images/about-us/Mark_Clemens.webp';
import photoJuanFranciscoNinImg from 'images/about-us/Juan_Francisco_Nin.webp';
import photoDanielArmasImg from 'images/about-us/Daniel_Armas.webp';
import photoLenardSweetingImg from 'images/about-us/Lenard_Sweeting.webp';
import photoMihaelaPoiataImg from 'images/about-us/Mihaela_Poiata.webp';
import photoDariaGardasImg from 'images/about-us/Daria_Gardas.webp';
import photoDorinGoraImg from 'images/about-us/Dorin_Gora.webp';
import photoTatianaIlianImg from 'images/about-us/Tatiana_Ilian.webp';
import photoAnaPaduretImg from 'images/about-us/Ana_Paduret.webp';
import photoSergiuChitanuImg from 'images/about-us/Sergiu_Chitanu.webp';
import photoAnaBurlacImg from 'images/about-us/photoAnaBurlac.webp';
import photoConstantinCebanImg from 'images/about-us/photoConstantinCeban.webp';
import photoGlebReznicencoImg from 'images/about-us/photoGlebReznicenco.webp';
import photoEugeniuCupcinencoImg from 'images/about-us/photoEugeniuCupcinenco.webp';
import photoMihailUliniciImg from 'images/about-us/photoMihailUlinici.webp';
import photoOctavianMantalutaImg from 'images/about-us/photoOctavianMantaluta.webp';
import photoOxanaMagaluImg from 'images/about-us/photoOxanaMagalu.webp';
import photoRodionDanuImg from 'images/about-us/photoRodionDanu.webp';
import photoRuslanBaxaneanImg from 'images/about-us/photoRuslanBaxanean.webp';
import photoSergiuTasmaliImg from 'images/about-us/photoSergiuTasmali.webp';
import photoValeriaTulbureImg from 'images/about-us/photoValeriaTulbure.webp';
import photoOlgaMelnicImg from 'images/about-us/photoOlgaMelnic.webp';
import photoAlexandruBacinschiiImg from 'images/about-us/photoAlexandruBacinschii.webp';
import photoDumitruPinzariImg from 'images/about-us/photoDumitruPinzari.webp';
import photoEdgarDacinImg from 'images/about-us/photoEdgarDacin.webp';

import slide1Img from 'images/about-us/slide1.webp';
import slide2Img from 'images/about-us/slide2.webp';
import slide3Img from 'images/about-us/slide3.webp';
import slide4Img from 'images/about-us/slide4.webp';
import slide5Img from 'images/about-us/slide5.webp';
import slide6Img from 'images/about-us/slide6.webp';
import slide7Img from 'images/about-us/slide7.webp';
import slide8Img from 'images/about-us/slide8.webp';
import slide9Img from 'images/about-us/slide9.webp';
import slide10Img from 'images/about-us/slide10.webp';
import slide11Img from 'images/about-us/slide11.webp';
import slide12Img from 'images/about-us/slide12.webp';
import slide13Img from 'images/about-us/slide13.webp';
import slide14Img from 'images/about-us/slide14.webp';
import slide15Img from 'images/about-us/slide15.webp';
import slide16Img from 'images/about-us/slide16.webp';
import slide17Img from 'images/about-us/slide17.webp';
import slide18Img from 'images/about-us/slide18.webp';
import slide19Img from 'images/about-us/slide19.webp';
import slide20Img from 'images/about-us/slide20.webp';
import slide21Img from 'images/about-us/slide21.webp';
import slide22Img from 'images/about-us/slide22.webp';
import slide23Img from 'images/about-us/slide23.webp';
import slide24Img from 'images/about-us/slide24.webp';
import slide25Img from 'images/about-us/slide25.webp';
import slide26Img from 'images/about-us/slide26.webp';
import slide27Img from 'images/about-us/slide27.webp';
import slide28Img from 'images/about-us/slide28.webp';
import slide29Img from 'images/about-us/slide29.webp';
import slide30Img from 'images/about-us/slide30.webp';
import slide31Img from 'images/about-us/slide31.webp';
import slide32Img from 'images/about-us/slide32.webp';
import slide33Img from 'images/about-us/slide33.webp';
import slide34Img from 'images/about-us/slide34.webp';
import slide35Img from 'images/about-us/slide35.webp';
import slide36Img from 'images/about-us/slide36.webp';
import slide37Img from 'images/about-us/slide37.webp';
import slide38Img from 'images/about-us/slide38.webp';
import slide39Img from 'images/about-us/slide39.webp';
import slide40Img from 'images/about-us/slide40.webp';
import slide41Img from 'images/about-us/slide41.webp';
import slide42Img from 'images/about-us/slide42.webp';
import slide43Img from 'images/about-us/slide43.webp';
import bgImageHeaderImg from 'images/about-us/bgImageHeader.webp';
import bgImageLeadershipImg from 'images/about-us/bgImageLeadership.webp';
import leadershipImg from 'images/about-us/Leadership.webp';
import bgImageProudMembersImg from 'images/about-us/bgImageProudMembers.webp';

export const slide1 = (slide1Img as any).src || slide1Img;
export const slide2 = (slide2Img as any).src || slide2Img;
export const slide3 = (slide3Img as any).src || slide3Img;
export const slide4 = (slide4Img as any).src || slide4Img;
export const slide5 = (slide5Img as any).src || slide5Img;
export const slide6 = (slide6Img as any).src || slide6Img;
export const slide7 = (slide7Img as any).src || slide7Img;
export const slide8 = (slide8Img as any).src || slide8Img;
export const slide9 = (slide9Img as any).src || slide9Img;
export const slide10 = (slide10Img as any).src || slide10Img;
export const slide11 = (slide11Img as any).src || slide11Img;
export const slide12 = (slide12Img as any).src || slide12Img;
export const slide13 = (slide13Img as any).src || slide13Img;
export const slide14 = (slide14Img as any).src || slide14Img;
export const slide15 = (slide15Img as any).src || slide15Img;
export const slide16 = (slide16Img as any).src || slide16Img;
export const slide17 = (slide17Img as any).src || slide17Img;
export const slide18 = (slide18Img as any).src || slide18Img;
export const slide19 = (slide19Img as any).src || slide19Img;
export const slide20 = (slide20Img as any).src || slide20Img;
export const slide21 = (slide21Img as any).src || slide21Img;
export const slide22 = (slide22Img as any).src || slide22Img;
export const slide23 = (slide23Img as any).src || slide23Img;
export const slide24 = (slide24Img as any).src || slide24Img;
export const slide25 = (slide25Img as any).src || slide25Img;
export const slide26 = (slide26Img as any).src || slide26Img;
export const slide27 = (slide27Img as any).src || slide27Img;
export const slide28 = (slide28Img as any).src || slide28Img;
export const slide29 = (slide29Img as any).src || slide29Img;
export const slide30 = (slide30Img as any).src || slide30Img;
export const slide31 = (slide31Img as any).src || slide31Img;
export const slide32 = (slide32Img as any).src || slide32Img;
export const slide33 = (slide33Img as any).src || slide33Img;
export const slide34 = (slide34Img as any).src || slide34Img;
export const slide35 = (slide35Img as any).src || slide35Img;
export const slide36 = (slide36Img as any).src || slide36Img;
export const slide37 = (slide37Img as any).src || slide37Img;
export const slide38 = (slide38Img as any).src || slide38Img;
export const slide39 = (slide39Img as any).src || slide39Img;
export const slide40 = (slide40Img as any).src || slide40Img;
export const slide41 = (slide41Img as any).src || slide41Img;
export const slide42 = (slide42Img as any).src || slide42Img;
export const slide43 = (slide43Img as any).src || slide43Img;
export const bgImageHeader = (bgImageHeaderImg as any).src || bgImageHeaderImg;
export const bgImageLeadership = (bgImageLeadershipImg as any).src || bgImageLeadershipImg;
export const leadership = (leadershipImg as any).src || leadershipImg;
export const bgImageProudMembers = (bgImageProudMembersImg as any).src || bgImageProudMembersImg;
export const photoAndrianLeca = (photoAndrianLecaImg as any).src || photoAndrianLecaImg;
export const photoAlexandrinPatron = (photoAlexandrinPatronImg as any).src || photoAlexandrinPatronImg;
export const photoButchWilson = (photoButchWilsonImg as any).src || photoButchWilsonImg;
export const photoDanaSinger = (photoDanaSingerImg as any).src || photoDanaSingerImg;
export const photoEcaterinaSharapova = (photoEcaterinaSharapovaImg as any).src || photoEcaterinaSharapovaImg;
export const photoElenaLuca = (photoElenaLucaImg as any).src || photoElenaLucaImg;
export const photoJosephDiMelis = (photoJosephDiMelisImg as any).src || photoJosephDiMelisImg;
export const photoMihaiBudac = (photoMihaiBudacImg as any).src || photoMihaiBudacImg;
export const photoRuxandraCreizan = (photoRuxandraCreizanImg as any).src || photoRuxandraCreizanImg;
export const photoSergheiBusmachiu = (photoSergheiBusmachiuImg as any).src || photoSergheiBusmachiuImg;
export const photoDumitruBoscanean = (photoDumitruBoscaneanImg as any).src || photoDumitruBoscaneanImg;
export const photoValeriaLozovanu = (photoValeriaLozovanuImg as any).src || photoValeriaLozovanuImg;
export const photoAnthonyByfield = (photoAnthonyByfieldImg as any).src || photoAnthonyByfieldImg;
export const photoChristopherJohnson = (photoChristopherJohnsonImg as any).src || photoChristopherJohnsonImg;
export const photoJohnWinder = (photoJohnWinderImg as any).src || photoJohnWinderImg;
export const photoRajTank = (photoRajTankImg as any).src || photoRajTankImg;
export const photoRandallBrooks = (photoRandallBrooksImg as any).src || photoRandallBrooksImg;
export const photoRyanWheeler = (photoRyanWheelerImg as any).src || photoRyanWheelerImg;
export const photoSinaMohseninejad = (photoSinaMohseninejadImg as any).src || photoSinaMohseninejadImg;
export const photoTylerDuclos = (photoTylerDuclosImg as any).src || photoTylerDuclosImg;
export const photoDenisMezer = (photoDenisMezerImg as any).src || photoDenisMezerImg;
export const photoAndreiUreche = (photoAndreiUrecheImg as any).src || photoAndreiUrecheImg;
export const photoBenjimenSkiba = (photoBenjimenSkibaImg as any).src || photoBenjimenSkibaImg;
export const photoJohnathanDoyle = (photoJohnathanDoyleImg as any).src || photoJohnathanDoyleImg;
export const photoMattLutton = (photoMattLuttonImg as any).src || photoMattLuttonImg;
export const photoMatthewFranklin = (photoMatthewFranklinImg as any).src || photoMatthewFranklinImg;
export const photoQuranOsiris = (photoQuranOsirisImg as any).src || photoQuranOsirisImg;
export const photoSergiuCurea = (photoSergiuCureaImg as any).src || photoSergiuCureaImg;
export const photoWilliamCarithers = (photoWilliamCarithersImg as any).src || photoWilliamCarithersImg;
export const photoWilliamOld = (photoWilliamOldImg as any).src || photoWilliamOldImg;
export const photoDavidSumner = (photoDavidSumnerImg as any).src || photoDavidSumnerImg;
export const photoMohammedSadiqMabeko = (photoMohammedSadiqMabekoImg as any).src || photoMohammedSadiqMabekoImg;
export const photoAlexandruRailean = (photoAlexandruRaileanImg as any).src || photoAlexandruRaileanImg;
export const photoIonUntila = (photoIonUntilaImg as any).src || photoIonUntilaImg;
export const photoIonutCiobanu = (photoIonutCiobanuImg as any).src || photoIonutCiobanuImg;
export const photoIvanPoclitari = (photoIvanPoclitariImg as any).src || photoIvanPoclitariImg;
export const photoDanielaJurja = (photoDanielaJurjaImg as any).src || photoDanielaJurjaImg;
export const photoCristinaCocieru = (photoCristinaCocieruImg as any).src || photoCristinaCocieruImg;
export const photoVadimUncu = (photoVadimUncuImg as any).src || photoVadimUncuImg;
export const associationLogo1 = (associationLogo1Img as any).src || associationLogo1Img;
export const associationLogo2 = (associationLogo2Img as any).src || associationLogo2Img;
export const associationLogo3 = (associationLogo3Img as any).src || associationLogo3Img;
export const associationLogo4 = (associationLogo4Img as any).src || associationLogo4Img;
export const associationLogo5 = (associationLogo5Img as any).src || associationLogo5Img;
export const associationLogo6 = (associationLogo6Img as any).src || associationLogo6Img;
export const associationLogo7 = (associationLogo7Img as any).src || associationLogo7Img;
export const associationLogo8 = (associationLogo8Img as any).src || associationLogo8Img;
export const associationLogo9 = (associationLogo9Img as any).src || associationLogo9Img;
export const associationLogo10 = (associationLogo10Img as any).src || associationLogo10Img;
export const associationLogo11 = (associationLogo11Img as any).src || associationLogo11Img;
export const associationLogo12 = (associationLogo12Img as any).src || associationLogo12Img;
export const ourPartnersLogo1 = (ourPartnersLogo1Img as any).src || ourPartnersLogo1Img;
export const ourPartnersLogo2 = (ourPartnersLogo2Img as any).src || ourPartnersLogo2Img;
export const ourPartnersLogo3 = (ourPartnersLogo3Img as any).src || ourPartnersLogo3Img;
export const ourPartnersLogo4 = (ourPartnersLogo4Img as any).src || ourPartnersLogo4Img;
export const ourPartnersLogo5 = (ourPartnersLogo5Img as any).src || ourPartnersLogo5Img;
export const ourPartnersLogo6 = (ourPartnersLogo6Img as any).src || ourPartnersLogo6Img;
export const ourPartnersLogo9 = (ourPartnersLogo9Img as any).src || ourPartnersLogo9Img;
export const ourPartnersLogo10 = (ourPartnersLogo10Img as any).src || ourPartnersLogo10Img;
export const ourPartnersLogo11 = (ourPartnersLogo11Img as any).src || ourPartnersLogo11Img;
export const ourPartnersLogo12 = (ourPartnersLogo12Img as any).src || ourPartnersLogo12Img;
export const ourPartnersLogo13 = (ourPartnersLogo13Img as any).src || ourPartnersLogo13Img;
export const ourPartnersLogo14 = (ourPartnersLogo14Img as any).src || ourPartnersLogo14Img;
export const ourPartnersLogo15 = (ourPartnersLogo15Img as any).src || ourPartnersLogo15Img;
export const ourPartnersAlaska = (ourPartnersAlaskaImg as any).src || ourPartnersAlaskaImg;
export const ourPartnersAlaskaTelecom = (ourPartnersAlaskaTelecomImg as any).src || ourPartnersAlaskaTelecomImg;
export const ourPartnersAstoundLogo = (ourPartnersAstoundLogoImg as any).src || ourPartnersAstoundLogoImg;
export const ourPartnersAptitudeLogo = (ourPartnersAptitudeLogoImg as any).src || ourPartnersAptitudeLogoImg;
export const ourPartnersATTLogo = (ourPartnersATTLogoImg as any).src || ourPartnersATTLogoImg;
export const ourPartnersFrontierCommunicationsLogo =
  (ourPartnersFrontierCommunicationsLogoImg as any).src || ourPartnersFrontierCommunicationsLogoImg;
export const ourPartnersAlticeLogo = (ourPartnersAlticeLogoImg as any).src || ourPartnersAlticeLogoImg;
export const ourPartnersFatbeamLogo = (ourPartnersFatbeamLogoImg as any).src || ourPartnersFatbeamLogoImg;
export const ourPartnersEricssonLogo = (ourPartnersEricssonLogoImg as any).src || ourPartnersEricssonLogoImg;
export const ourPartnersMaxxSouthLogo = (ourPartnersMaxxSouthLogoImg as any).src || ourPartnersMaxxSouthLogoImg;
export const ourParnersSpectrumLogo = (ourParnersSpectrumLogoImg as any).src || ourParnersSpectrumLogoImg;
export const ourPartnersCharterLogo = (ourPartnersCharterLogoImg as any).src || ourPartnersCharterLogoImg;
export const ourPartnersComcastLogo = (ourPartnersComcastLogoImg as any).src || ourPartnersComcastLogoImg;
export const ourPartnersClearwaveLogo = (ourPartnersClearwaveLogoImg as any).src || ourPartnersClearwaveLogoImg;
export const ourPartnersConsolidatedLogo = (ourPartnersConsolidatedLogoImg as any).src || ourPartnersConsolidatedLogoImg;
export const ourPartnersDishLogo = (ourPartnersDishLogoImg as any).src || ourPartnersDishLogoImg;
export const ourPartnersWyyerdLogo = (ourPartnersWyyerdLogoImg as any).src || ourPartnersWyyerdLogoImg;
export const ourPartnersLumosLogo = (ourPartnersLumosLogoImg as any).src || ourPartnersLumosLogoImg;
export const ourPartnersTeslaLogo = (ourPartnersTeslaLogoImg as any).src || ourPartnersTeslaLogoImg;
export const teamDescriptionBgPhoto = (teamDescriptionBgPhotoImg as any).src || teamDescriptionBgPhotoImg;
export const teamDescriptionPhoto = (teamDescriptionPhotoImg as any).src || teamDescriptionPhotoImg;
export const photoJasonMcCoy = (photoJasonMcCoyImg as any).src || photoJasonMcCoyImg;
export const photoJuanDelCalvo = (photoJuanDelCalvoImg as any).src || photoJuanDelCalvoImg;
export const photoCharlesHouser = (photoCharlesHouserImg as any).src || photoCharlesHouserImg;
export const photoTatianaLeahovici = (photoTatianaLeahoviciImg as any).src || photoTatianaLeahoviciImg;
export const photoEdwardJares = (photoEdwardJaresImg as any).src || photoEdwardJaresImg;
export const photoKyleClausen = (photoKyleClausenImg as any).src || photoKyleClausenImg;
export const photoCraigTonks = (photoCraigTonksImg as any).src || photoCraigTonksImg;
export const photoIvanGalkin = (photoIvanGalkinImg as any).src || photoIvanGalkinImg;
export const photoRandyMantione = (photoRandyMantioneImg as any).src || photoRandyMantioneImg;
export const photoBrentCollins = (photoBrentCollinsImg as any).src || photoBrentCollinsImg;
export const photoIgorPapo = (photoIgorPapoImg as any).src || photoIgorPapoImg;
export const photoJohnathanMathewL = (photoJohnathanMathewLImg as any).src || photoJohnathanMathewLImg;
export const photoSteveSizemore = (photoSteveSizemoreImg as any).src || photoSteveSizemoreImg;
export const photoAlexandruBuse = (photoAlexandruBuseImg as any).src || photoAlexandruBuseImg;
export const photoBulatOleg = (photoBulatOlegImg as any).src || photoBulatOlegImg;
export const photoBrianBertrand = (photoBrianBertrandImg as any).src || photoBrianBertrandImg;
export const photoMatthewStewart = (photoMatthewStewartImg as any).src || photoMatthewStewartImg;
export const photoViktorPilgun = (photoViktorPilgunImg as any).src || photoViktorPilgunImg;
export const photoMarkClemens = (photoMarkClemensImg as any).src || photoMarkClemensImg;
export const photoJuanFranciscoNin = (photoJuanFranciscoNinImg as any).src || photoJuanFranciscoNinImg;
export const photoDanielArmas = (photoDanielArmasImg as any).src || photoDanielArmasImg;
export const photoLenardSweeting = (photoLenardSweetingImg as any).src || photoLenardSweetingImg;
export const photoMihaelaPoiata = (photoMihaelaPoiataImg as any).src || photoMihaelaPoiataImg;
export const photoDariaGardas = (photoDariaGardasImg as any).src || photoDariaGardasImg;
export const photoDorinGora = (photoDorinGoraImg as any).src || photoDorinGoraImg;
export const photoTatianaIlian = (photoTatianaIlianImg as any).src || photoTatianaIlianImg;
export const photoAnaPaduret = (photoAnaPaduretImg as any).src || photoAnaPaduretImg;
export const photoSergiuChitanu = (photoSergiuChitanuImg as any).src || photoSergiuChitanuImg;
export const photoAnaBurlac = (photoAnaBurlacImg as any).src || photoAnaBurlacImg;
export const photoConstantinCeban = (photoConstantinCebanImg as any).src || photoConstantinCebanImg;
export const photoGlebReznicenco = (photoGlebReznicencoImg as any).src || photoGlebReznicencoImg;
export const photoEugeniuCupcinenco = (photoEugeniuCupcinencoImg as any).src || photoEugeniuCupcinencoImg;
export const photoMihailUlinici = (photoMihailUliniciImg as any).src || photoMihailUliniciImg;
export const photoOctavianMantaluta = (photoOctavianMantalutaImg as any).src || photoOctavianMantalutaImg;
export const photoOxanaMagalu = (photoOxanaMagaluImg as any).src || photoOxanaMagaluImg;
export const photoRodionDanu = (photoRodionDanuImg as any).src || photoRodionDanuImg;
export const photoRuslanBaxanean = (photoRuslanBaxaneanImg as any).src || photoRuslanBaxaneanImg;
export const photoSergiuTasmali = (photoSergiuTasmaliImg as any).src || photoSergiuTasmaliImg;
export const photoValeriaTulbure = (photoValeriaTulbureImg as any).src || photoValeriaTulbureImg;
export const photoOlgaMelnic = (photoOlgaMelnicImg as any).src || photoOlgaMelnicImg;
export const photoAlexandruBacinschii = (photoAlexandruBacinschiiImg as any).src || photoAlexandruBacinschiiImg;
export const photoDumitruPinzari = (photoDumitruPinzariImg as any).src || photoDumitruPinzariImg;
export const photoEdgarDacin = (photoEdgarDacinImg as any).src || photoEdgarDacinImg;
